// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

var jQuery = require("jquery")
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;
require("packs/jquery.serializejson")
import { setupNewIcons } from "packs/font_awesome_icons.js"
import mixpanel from 'mixpanel-browser'

export const rails_ujs = require("@rails/ujs")
rails_ujs.start()
global.Rails = Rails;

require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("select2/dist/js/select2.full")

import LocalTime from "local-time"
LocalTime.start()

import "bootstrap"
import "../stylesheets/application.scss"
import Gmaps from "lib/gmaps_google"
console.log('Gmaps', Gmaps)

//import "dropzone"

// import "@fortawesome/fontawesome-free/js/all";

$(document).on("turbolinks:load", () => {
  setupNewIcons();

  const currentUserId = document.body.dataset.currentUserId;
  const mixpanelProjectKey = document.body.dataset.mixpanelProjectKey;
  
  if (currentUserId && mixpanelProjectKey) {
    mixpanel.init(mixpanelProjectKey, {autocapture: true});
    mixpanel.identify(currentUserId);
  }

  $('form[disabled]').each(function() {
    // Disable all input, select, textarea, and button fields inside this form
    $(this).find('input, select, textarea, button').prop('disabled', true);
  });

  $('[data-toggle="tooltip"]').tooltip()
  $('[data-toggle="popover"]').popover()

  $("select.select2:not(.select2-loaded, .tag-search)").addClass("select2-loaded").select2({ theme: "bootstrap4" });
  $("select.select2:not(.select2-loaded, .channel-languages)").addClass("select2-loaded").select2({ theme: "bootstrap4" });

  // Color select with swatches
  function formatColorOption(state) {
    if (!state.id) { return state.text; }
    var $el = $(state.element);
    var color = $el.data('color');
    var text = state.text || '';
    var $node = $(
      '<span class="color-swatch-option d-flex align-items-center">'
      + '<span class="swatch-box mr-2"></span>'
      + '<span class="swatch-label"></span>'
      + '</span>'
    );
    $node.find('.swatch-box').css({
      backgroundColor: color,
      width: '14px',
      height: '14px',
      display: 'inline-block',
      borderRadius: '3px',
      border: '1px solid rgba(0,0,0,0.15)'
    });
    $node.find('.swatch-label').text(text);
    return $node;
  }

  function formatColorSelection(state) {
    if (!state.id) { return state.text; }
    var $el = $(state.element);
    var color = $el.data('color');
    var text = state.text || '';
    var $node = $(
      '<span class="color-swatch-selection d-flex align-items-center">'
      + '<span class="swatch-box mr-1"></span>'
      + '<span class="swatch-label"></span>'
      + '</span>'
    );
    $node.find('.swatch-box').css({
      backgroundColor: color,
      width: '12px',
      height: '12px',
      display: 'inline-block',
      borderRadius: '3px',
      border: '1px solid rgba(0,0,0,0.15)'
    });
    $node.find('.swatch-label').text(text);
    return $node;
  }

  $("select.color-select:not(.select2-loaded)").addClass("select2-loaded").select2({
    theme: "bootstrap4",
    width: 'resolve',
    templateResult: formatColorOption,
    templateSelection: formatColorSelection,
    escapeMarkup: function (m) { return m; }
  });

  // Labels picker: Select All behavior with indeterminate state
  function updateSelectAllState($container) {
    var $checks = $container.find('.label-checkbox');
    var $all = $container.find('.select-all');
    var total = $checks.length;
    var checked = $checks.filter(':checked').length;
    if (checked === 0) {
      $all.prop('checked', false).prop('indeterminate', false);
    } else if (checked === total) {
      $all.prop('checked', true).prop('indeterminate', false);
    } else {
      $all.prop('checked', false).prop('indeterminate', true);
    }
  }

  // Initialize state on load
  $('.labels-picker').each(function() { updateSelectAllState($(this)); });

  // Delegate: header Select All toggles all
  $(document).on('change', '.labels-picker .select-all', function() {
    var $container = $(this).closest('.labels-picker');
    var checked = $(this).prop('checked');
    $container.find('.label-checkbox').prop('checked', checked).trigger('change');
    updateSelectAllState($container);
  });

  // Delegate: individual checkbox updates header state
  $(document).on('change', '.labels-picker .label-checkbox', function() {
    var $container = $(this).closest('.labels-picker');
    updateSelectAllState($container);
  });

  // special select2 for tags
  $("select.select2.tag-search:not(.select2-loaded)").addClass("select2-loaded").select2({ 
    theme: "bootstrap4", 
    ajax: { 
      url: '/issues/tags.json', 
      dataType: 'json',
    },
    templateResult: function (tag) {
      if (!tag.priority || tag.priority == 0) { return tag.text; }
      var $tag = $('<b class="text-warning">' + tag.text+ '</b>');
      return $tag;
    }
  });

  $('select.select2.extra-tags').addClass("select2-loaded").select2({ theme: "bootstrap4", placeholder: "Other Tags", ajax: {
      url: '/issues/tags.json',
      dataType: 'json',
    } });

  $('select.select2.task-terms').select2({ theme: "bootstrap4", tokenSeparators: [',', ', ', ' ']});

  $(".toggle-nav").click(function(e){
    e.preventDefault();
    // var toggleWidth = $(".sidebar2").width() > 219 ? 63 : 220;
    $(".sidebar2").toggleClass("sm-sidebar");
  })

  if (window.location.href.includes('/lists')) {
    $("#collapseFiltersList").addClass("show");
  } else if (window.location.href.includes('/platform_keys')) {
    $("#collapseFiltersList").addClass("show");
  } else if (window.location.href.includes('/issues')) {
    $("#collapseFiltersIssue").addClass("show");
  } else if (window.location.href.includes('/submissions')) {
    $("#collapseFiltersIssue").addClass("show");
  } else if (window.location.href.includes('/submission_reviews')) {
    $("#collapseFiltersIssue").addClass("show");
  } else if (window.location.pathname == "/") {
    $("#collapseFiltersIssue").addClass("show");
  } else if (window.location.href.includes('/narratives')) {
    $("#collapseFiltersNarrative").addClass("show");
  } else if (window.location.href.includes('/channels')){
    $("#collapseFiltersChannel").addClass("show");
  } else {
    $("#collapseFiltersList").removeClass("show");
  }

  if (window.innerWidth < 1210) {
    $(".sidebar2").addClass("sm-sidebar");
  } else {
    $(".sidebar2").removeClass("sm-sidebar");
  }

  $(".post-item.post-template").on("mouseenter",function() {
    $(this).find(".carousel").carousel('cycle');
  }).on("mouseleave", function() {
    $(".carousel").carousel('pause');
  });

  if(window.location.pathname.includes("/dashboards/")){
    $("body").on('click', ".custom-control.custom-checkbox label", function(event) {
      event.preventDefault();
      let checkbox_id = $(this).attr("for");
      let checkbox = $(this).parent().find(`input#${checkbox_id}[type='checkbox']`);
    
      if (checkbox.is(":checked")) {
        checkbox.prop("checked", false);
      } else {
        checkbox.prop("checked", true);
      }

      checkbox.trigger("change");
    });
  }

});


$(document).on("turbolinks:before-cache", () => {
  $("select.select2.select2-loaded").removeClass("select2-loaded").select2("destroy");
});

function removeEmptyValues(object) {
  for (var key in object) {
      if (object.hasOwnProperty(key)) {
          var value = object[key];
          if (value === null || value === undefined || value === '') {
              delete object[key];
          }
      }
  }
}

require("trix")
require("packs/helpers")
require("@rails/actiontext")
require("packs/agents")
require("packs/issues")
require("packs/tasks")
require("packs/training_tasks")
require("packs/channels")
require("packs/lists")
require("packs/monitoring")
require("packs/project_posts")
require("packs/users")
require("packs/narratives")
require("packs/slider")
require("packs/syllabuses")
require("packs/assignment_templates")
require('packs/assignments')
// require('packs/people')
require('packs/projects')
require('packs/vega_chart')
require('packs/channel_graphs')
require('packs/actors')

require('local-time')
// require("chartkick")
// require("lib/Chart.bundle.js")
// import "chartkick/chart.js"
require("chartkick/chart.js")

require("packs/platform_keys")
var d3 = require("d3")
global.d3 = window.d3 = d3;
var d3cloud = require("d3-cloud")
global.d3cloud = window.d3cloud = d3cloud;
// require("@rails/ujs").start()
// require("@rails/activestorage").start()
// require("channels")
// require("gmaps_google")

// import 'underscore'

window.vegaEmbed = require("vega-embed").default

import 'controllers'
